import {Action} from "@ngrx/store";
import {IAvgPriceVendorData, IBestItemsData, IFillRateData, IKeyIndicatorData, IKeyIndicatorSupplierData, IMarketShareData, IProfitabilityData, IPromoAnalysisData, IServiceLevelTableData, IStockRotationData, IStockRotationParam} from "../../models/reports/insights.interface";

export enum EReportsInsightsActions {
  GetFillRate = '[Reports Insight] Get FillRate Report Data',
  GetFillRateSuccess = '[Reports Insight] Get FillRate Report Data Success',
  GetFillRateFailure = '[Reports Insight] Get FillRate Report Data Failure',

  GetStockRotation = '[Reports Insight] Get Stock Rotation Report Data',
  GetStockRotationSuccess = '[Reports Insight] Get Stock Rotation Report Data Success',
  GetStockRotationFailure = '[Reports Insight] Get Stock Rotation Report Data Failure',

  GetMarketShare = '[Reports Insight] Get MarketShare Report Data',
  GetMarketShareSuccess = '[Reports Insight] Get MarketShare Report Data Success',
  GetMarketShareFailure = '[Reports Insight] Get MarketShare Report Data Failure',

  GetKeyIndicators = '[Reports Insight] Get KeyIndicators Report Data',
  GetKeyIndicatorsSuccess = '[Reports Insight] Get KeyIndicators Report Data Success',
  GetKeyIndicatorsFailure = '[Reports Insight] Get KeyIndicators Report Data Failure',

  GetProfitability = '[Reports Insight] Get Profitability Report Data',
  GetProfitabilitySuccess = '[Reports Insight] Get Profitability Report Data Success',
  GetProfitabilityFailure = '[Reports Insight] Get Profitability Report Data Failure',

  GetPromo = '[Reports Insight] Get Promo Report Data',
  GetPromoSuccess = '[Reports Insight] Get Promo Report Data Success',
  GetPromoFailure = '[Reports Insight] Get Promo Report Data Failure',

  GetServiceLevel = '[Reports Insight] Get ServiceLevel Report Data',
  GetServiceLevelSuccess = '[Reports Insight] Get ServiceLevel Report Data Success',
  GetServiceLevelFailure = '[Reports Insight] Get ServiceLevel Report Data Failure',

  GetBestItems = '[Reports Insight] Get BestItems Report Data',
  GetBestItemsSuccess = '[Reports Insight] Get BestItems Report Data Success',
  GetBestItemsFailure = '[Reports Insight] Get BestItems Report Data Failure',

  GetKeyIndicatorsSuppliers = '[Reports Insight] Get KeyIndicatorsSuppliers Report Data',
  GetKeyIndicatorsSuppliersSuccess = '[Reports Insight] Get KeyIndicatorsSuppliers Report Data Success',
  GetKeyIndicatorsSuppliersFailure = '[Reports Insight] Get KeyIndicatorsSuppliers Report Data Failure',

  GetAvgPrice = '[Reports Insight] Get AvgPrice Report Data',
  GetAvgPriceSuccess = '[Reports Insight] Get AvgPrice Report Data Success',
  GetAvgPriceFailure = '[Reports Insight] Get AvgPrice Report Data Failure',

}

export class GetFillRate implements Action {
  public readonly type = EReportsInsightsActions.GetFillRate;
}
export class GetFillRateSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetFillRateSuccess;
  constructor(public payload: Array<IFillRateData>){}
}
export class GetFillRateFailure implements Action {
  public readonly type = EReportsInsightsActions.GetFillRateFailure;
}
//----------------------------------------
export class GetStockRotation implements Action {
  public readonly type = EReportsInsightsActions.GetStockRotation;
}
export class GetStockRotationSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetStockRotationSuccess;
  constructor(public payload: Array<IStockRotationData>){}
}
export class GetStockRotationFailure implements Action {
  public readonly type = EReportsInsightsActions.GetStockRotationFailure;
}

//----------------------------------------
export class GetMarketShare implements Action {
  public readonly type = EReportsInsightsActions.GetMarketShare;

}
export class GetMarketShareSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetMarketShareSuccess;
  constructor(public payload: Array<IMarketShareData>){}
}
export class GetMarketShareFailure implements Action {
  public readonly type = EReportsInsightsActions.GetMarketShareFailure;
}

//----------------------------------------
export class GetKeyIndicators implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicators;

}
export class GetKeyIndicatorsSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicatorsSuccess;
  constructor(public payload: Array<IKeyIndicatorData>){}
}
export class GetKeyIndicatorsFailure implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicatorsFailure;
}

//----------------------------------------
export class GetPromo implements Action {
  public readonly type = EReportsInsightsActions.GetPromo;

}
export class GetPromoSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetPromoSuccess;
  constructor(public payload: Array<IPromoAnalysisData>){}
}
export class GetPromoFailure implements Action {
  public readonly type = EReportsInsightsActions.GetPromoFailure;
}

//----------------------------------------
export class GetServiceLevel implements Action {
  public readonly type = EReportsInsightsActions.GetServiceLevel;

}
export class GetServiceLevelSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetServiceLevelSuccess;
  constructor(public payload: Array<IServiceLevelTableData>){}
}
export class GetServiceLevelFailure implements Action {
  public readonly type = EReportsInsightsActions.GetServiceLevelFailure;
}

//----------------------------------------
export class GetBestItems implements Action {
  public readonly type = EReportsInsightsActions.GetBestItems;

}
export class GetBestItemsSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetBestItemsSuccess;
  constructor(public payload: Array<IBestItemsData>){}
}
export class GetBestItemsFailure implements Action {
  public readonly type = EReportsInsightsActions.GetBestItemsFailure;
}

//----------------------------------------
export class GetKeyIndicatorsSuppliers implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicatorsSuppliers;

}
export class GetKeyIndicatorsSuppliersSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicatorsSuppliersSuccess;
  constructor(public payload: Array<IKeyIndicatorSupplierData>){}
}
export class GetKeyIndicatorsSuppliersFailure implements Action {
  public readonly type = EReportsInsightsActions.GetKeyIndicatorsSuppliersFailure;
}

//----------------------------------------
export class GetAvgPrice implements Action {
  public readonly type = EReportsInsightsActions.GetAvgPrice;

}
export class GetAvgPriceSuccess implements Action {
  public readonly type = EReportsInsightsActions.GetAvgPriceSuccess;
  constructor(public payload: Array<IAvgPriceVendorData>){}
}
export class GetAvgPriceFailure implements Action {
  public readonly type = EReportsInsightsActions.GetAvgPriceFailure;
}

//----------------------------------------
export class GetProfitability implements Action {
  public readonly type = EReportsInsightsActions.GetProfitability;

}
export class GetProfitabilitySuccess implements Action {
  public readonly type = EReportsInsightsActions.GetProfitabilitySuccess;
  constructor(public payload: Array<IProfitabilityData>){}
}
export class GetProfitabilityFailure implements Action {
  public readonly type = EReportsInsightsActions.GetProfitabilityFailure;
}

export type ReportsInsightsActions =
  GetFillRate |
  GetFillRateSuccess |
  GetFillRateFailure |

  GetStockRotation |
  GetStockRotationSuccess |
  GetStockRotationFailure |

  GetMarketShare |
  GetMarketShareSuccess |
  GetMarketShareFailure |

  GetKeyIndicators |
  GetKeyIndicatorsSuccess |
  GetKeyIndicatorsFailure |

  GetProfitability |
  GetProfitabilitySuccess |
  GetProfitabilityFailure |

  GetPromo |
  GetPromoSuccess |
  GetPromoFailure |

  GetServiceLevel |
  GetServiceLevelSuccess |
  GetServiceLevelFailure |

  GetBestItems |
  GetBestItemsSuccess |
  GetBestItemsFailure |

  GetKeyIndicatorsSuppliers |
  GetKeyIndicatorsSuppliersSuccess |
  GetKeyIndicatorsSuppliersFailure |

  GetAvgPrice |
  GetAvgPriceSuccess |
  GetAvgPriceFailure ;
